import React, { useEffect, useState } from 'react';
import { useStoreon } from 'storeon/react';
import { useFieldArray, useFormContext } from 'react-hook-form';
import PropTypes from 'prop-types';

import InputWarranty from '../InputWarranty';
import SelectWarranty from '../SelectWarranty';

import FileUploadFieldWarranty from "../FileUploadFieldWarranty/FileUploadFieldWarranty";
import InfoWarranty from '../InfoWarranty/InfoWarranty';

const BlockDescribeProblemWarrantyRecallForm = ( props ) => {
        const [isVisible, setIsVisible] = useState( [false] );
        const { index: blockIndex, disabled = '', idForm } = props;
        const { trigger, errors, register, setValue, watch } = useFormContext();
        const { groups } = useStoreon( 'groups' );
        const { fields, remove, append } = useFieldArray( {
            name: 'your_project',
        } );

        const productNameValue = watch()?.your_project ? watch()?.your_project[0]?.product_name : '';
        const [indexChangeSelect, setIndexChangeSelect] = useState( 0 );
        const [productStyleValue, setProductStyleValue] = useState( '' );
        const [productStyleSelected, setProductStyleSelected] = useState( [] );
        const [refresh, setRefresh] = useState( false );
        const getProductStyleValue = ( index ) => {
            return watch().your_project ? watch().your_project[index]?.product_style : ''
        }

        const getOptionsProductName = ( index ) => {
            const optionsProductNameHung = [
                {
                    label: '1615 Sliding Glass Door',
                    value: '1615 Sliding Glass Door',
                },
                {
                    label: '1617 Sliding Glass Door',
                    value: '1617 Sliding Glass Door',
                },
                {
                    label: 'Window World 4000 Series sliding glass doors',
                    value: 'Window World 4000 Series sliding glass doors',
                },
                {
                    label: 'Window World 8000 Series sliding glass doors',
                    value: 'Window World 8000 Series sliding glass doors',
                },
            ];

            const optionsProductNameSlidingDoor = [{
                label: '1620-Impact',
                value: '1620-Impact',
            }];

            return getProductStyleValue( index ) !== 'Sliding Door' ? optionsProductNameSlidingDoor : optionsProductNameHung;
        }

        useEffect( () => {
            if ( productNameValue ) {
                register( "service_type" )
                productNameValue === '1620-Impact'
                    ? setValue( 'service_type', '1620 Impact WOCD Recall' )
                    : setValue( 'service_type', '1615 / 1617 Series Recall' );
            }
        }, [productNameValue] );

        useEffect( () => {
            if(productStyleValue){
                setProductStyleSelected([...productStyleSelected, true]);
            }
            if ( watch().your_project[indexChangeSelect].product_name) {
                setRefresh( true );
                setTimeout(()=>  setRefresh( false ),0);
            }
        }, [productStyleValue] );

        useEffect( () => {
            trigger();
        }, [trigger] );

        useEffect( () => {
            register( 'id_form' );
            setValue( 'id_form', idForm );
        }, [register, setValue, idForm] );

        return (
            <fieldset className="form-block" disabled={disabled === '' ? groups[blockIndex].disabled : disabled}>
                <legend className="form-block__title">Product details</legend>
                {fields.map( ( item, index ) => {
                    return (
                        <div className={`block-form block--describe-your-problem`} key={item.id}>
                            {!!index && (
                                <>
                                    <h2 className={'block__title'}>Door/Window Problem #{index + 1}</h2>
                                    <button
                                        className={`button button--remove-problem`}
                                        type="button"
                                        aria-label="Remove problem block"
                                        onClick={() => {
                                            remove( index )
                                            productStyleSelected.pop();
                                            setProductStyleSelected([...productStyleSelected])
                                        }}
                                    >
                                        ×
                                    </button>
                                </>
                            )}
                            <div className="row">
                                <div className="col col-12 col-sm-4">
                                    <InputWarranty
                                        type={'date'}
                                        name={`your_project[${index}].date_of_purchase`}
                                        label={'Date of Purchase'}
                                        min={'1900-01-01'}
                                    />
                                </div>
                                <div className="col col-12 col-sm-4">
                                    <SelectWarranty
                                        idForm={idForm}
                                        label="Product Style"
                                        indexSection={index}
                                        productStyleValue={setProductStyleValue}
                                        getIndexChangeSelect={setIndexChangeSelect}
                                        name={`your_project[${index}].product_style`}
                                        options={[
                                            {
                                                label: 'Single Hung',
                                                value: 'Single Hung',
                                            },
                                            {
                                                label: 'Double Hung',
                                                value: 'Double Hung',
                                            },
                                            {
                                                label: 'Sliding Door',
                                                value: 'Sliding Door',
                                            },
                                        ]}
                                        rules={{
                                            required: 'This field is required.',
                                        }}
                                    />
                                </div>
                                <div className="col col-12 col-sm-4">
                                    {(indexChangeSelect !== index ? true : !refresh) && productStyleSelected[index] ?
                                        <SelectWarranty
                                            changeState={() => console.log( 2123123 )}
                                            label="Product name"
                                            name={`your_project[${index}].product_name`}
                                            options={getOptionsProductName( index )}
                                            rules={{
                                                required: 'This field is required.',
                                            }}
                                        /> : ''}
                                </div>
                                {getProductStyleValue( index ) !== 'Sliding Door' && getProductStyleValue( index ) ?
                                    <div className="col col-12">
                                        <InfoWarranty styleText={'text-grey mb-18'}>
                                            If you do not have the order number, upload a photo of the AAMA label and/or
                                            photos of the tilt latches and Holds.
                                        </InfoWarranty>
                                    </div> : ''
                                }
                                <div className="col col-12 col-sm-4">
                                    <FileUploadFieldWarranty
                                        hint={{
                                            info: 'You can upload up to four pictures to accompany this window/door. Files must be less than 256 MB. Allowed file types: png gif jpg jpeg.',
                                        }}
                                        isVisible={isVisible}
                                        changeState={setIsVisible}
                                        id={index}
                                        name={`your_project[${index}].download_files`}
                                        imageUpload={true}
                                    />
                                </div>
                            </div>

                            {!errors.your_project && index === fields.length - 1 && (
                                <button className={`button button--add-problem`} type="button"
                                        onClick={() => append()}>
                                    + Add another door/window
                                </button>
                            )}
                        </div>
                    );
                } )}
                {!groups[blockIndex].disabled &&
                groups[blockIndex + 1] &&
                groups[blockIndex + 1].disabled && (
                    <div className={'form-block__error'}>
                        You must fill in all required fields prior to moving to the next section.
                    </div>
                )}
            </fieldset>
        );
    }
;

BlockDescribeProblemWarrantyRecallForm.propTypes = {
    index: PropTypes.number.isRequired,
};


export default BlockDescribeProblemWarrantyRecallForm;
